var ContextMenuView = require('contextmenuview');
var Formatter = require('formatter');
var util = require('../lib/util.es6');

require('emoji.scss');


var EmojiContextMenuView = ContextMenuView.extend({
    el: '#emojiContextMenu',
    initialize: function (options) {
        this.afterHide = _.bind(this.deactivateCell, this);
        ContextMenuView.prototype.initialize.call(this, options);
        this.formatter = new Formatter();

        this.list = this.$('.emojiContextMenu__list');
        this.picker = this.$('.emojiContextMenu__picker');
        this.searchInput = this.$('.emojiContextMenu__search');
        this.previewEmoji = this.$('.emojiContextMenu__previewEmoji');
        this.previewName = this.$('.emojiContextMenu__previewName');
    },
    events: $.extend({}, ContextMenuView.prototype.events, {
        'click .emojiContextMenu__pick': 'clickPick',
        'buttonClick .emojiContextMenu__pick': 'clickPick',
        'click .emojiContextMenu__skinPick': 'clickSkin',
        'buttonClick .emojiContextMenu__skinPick': 'clickSkin',
        'mouseenter .emojiContextMenu__pick': 'hoverPick',
        'mouseenter .emojiContextMenu__skinPick': 'hoverSkin',
        'input .emojiContextMenu__search': 'onSearchInput',
        'submit .emojiContextMenu__searchForm': 'onSearchSubmit'
    }),
    clickPick: function (e) {
        window.getSelection().removeAllRanges();
        this.focusSearch();
        e.preventDefault();
        if (!e.shiftKey) {
            this.hide();
            this.reset();
        }
        this.buffer.trigger(this.action, $(e.currentTarget).data('colon'), this.actionData);
    },
    hoverPick: function (e) {
        var colon = $(e.currentTarget).data('colon');
        var idx = $(e.currentTarget).data('idx');
        this.previewEmoji.html(emoji.replace_colons(colon));
        var names = [];
        _.each(emoji.data[idx][3].concat(emoji.colon_aliases[idx] || []), function (c) {
            if (c.indexOf('&') === -1) {
                names.push('<span class="emojiContextMenu__previewNameItem">:' + this.formatter.escapeText(c) + ':</span>');
            }
        }, this);
        this.previewName.html(names.join(''));
    },
    clickSkin: function (e) {
        window.getSelection().removeAllRanges();
        this.focusSearch();
        e.preventDefault();
        this.setSkinTone($(e.currentTarget).data('tone'));
        this.render();
        return false;
    },
    hoverSkin: function (e) {
        var tone = $(e.currentTarget).data('tone');
        var idx = emoji.skin_tone_to_idx(tone);
        if (idx) {
            this.previewEmoji.html(emoji.replace_unified(tone));
            this.previewName.text(emoji.data[idx][3][0]);
        } else {
            this.previewEmoji.html('');
            this.previewName.text('No skin tone');
        }
    },
    onSearchInput: function (e) {
        this.getCandidates(this.searchInput.val());
        this.resetPreview();
        this.render();
    },
    onSearchSubmit: function (e) {
        e.preventDefault();
    },
    previewHints: [
        'Hint: Shift-click to choose more than one'
    ],
    reactionPreviewHints: [
        'Hint: Type +:emoji: in the chat box and use Shift+Up/Down'
    ],
    resetPreview: function () {
        this.previewEmoji.html('');
        var hints = this.previewHints;
        if (this.reaction) {
            hints = hints.concat(this.reactionPreviewHints);
        }
        this.previewName.text(_.sample(hints));
    },
    reset: function () {
        this.searchInput.val('');
        this.onSearchInput();
    },
    render: function () {
        if (this.searchCandidates) {
            this.renderSearchResults();
        } else {
            this.renderEmoji();
        }
    },
    getCandidates: function (input) {
        this.searchCandidates = util.matchEmoji(input);
    },
    deactivateCell: function () {
        this.triggerEl.attr('aria-expanded', 'false');
        if (this.triggerEl && this.triggerEl.is('.emojicell')) {
            this.triggerEl.removeClass('menuActive');
        }
    },
    reactions: [
        '+1',
        '-1',
        'ok_hand',
        'wave',
        '<3',
        'star',
        'fire',
        'tada',
        'joy',
        'laughing',
        'hugging_face',
        'open_mouth',
        'cry',
        'confused',
        'thinking_face',
        'rage'
    ],
    renderSkinTonePicker: function () {
        var html = [];
        var noneClasses = ['emojiContextMenu__skinPick', 'emojiContextMenu__emoji', 'emojiContextMenu__skinPick--none'];
        var skinTone = this.getSkinTone();
        if (!skinTone) {
            noneClasses.push('emojiContextMenu__skinPick--selected');
        }
        html.push('<span role="button" tabindex="0" class="' + noneClasses.join(' ') + '"><i class="fa fa-square title="no skin tone" aria-label="no skin tone"></i></span>');
        _.each(emoji.map.category['Component'], function (item) {
            if (item.item[7] !== 'skin-tone') {
                return;
            }
            var px = item.item[4];
            var py = item.item[5];
            var title = item.item[3][0];
            var mul = 100 / (emoji.sheet_size - 1);
            var attrs = {
                classNames: ['emojiContextMenu__skin'],
                style: 'background-position:'+(mul*px)+'% '+(mul*py)+'%;',
                title: title,
                'aria-label': title
            };
            var classNames = ['emojiContextMenu__skinPick', 'emojiContextMenu__emoji'];
            if (item.item[0][0] === skinTone) {
                classNames.push('emojiContextMenu__skinPick--selected');
            }
            var skinPick = '<span role="button" tabindex="0" class="' + classNames.join(' ') + '" data-tone="' + item.item[0][0] + '">' + emoji.wrap_span('', attrs) + '</span>';
            html.push(skinPick);
        }, this);
        this.picker[0].innerHTML = html.join('');
    },
    renderSearchResults: function () {
        this.renderSkinTonePicker();
        var resultsHtml;
        if (this.searchCandidates.length) {
            var skinTone = this.getSkinTone();
            resultsHtml = ['<h2>Search Results</h2>'];
            resultsHtml = resultsHtml.concat(_.map(this.searchCandidates, function (result) {
                return this.renderSingleEmoji(result.idx, emoji.data[result.idx], skinTone);
            }, this));
        } else {
            resultsHtml = ['<h2>No Results</h2>'];
        }
        this.list[0].innerHTML = resultsHtml.join('');
    },
    renderSingleEmoji: function (key, item, skinTone) {
        var em = emoji.replacement(key, '', item[3][0], undefined, undefined, skinTone);
        var colon = emoji.idx_to_colon(key, skinTone);
        var emPick = '<span class="emojiContextMenu__pick emojiContextMenu__emoji" role="button" tabindex="0" data-colon="' + colon + '" data-idx="' + key + '">' + em + '</span><wbr>';
        return emPick;
    },
    getSkinTone: function () {
        return this.model.getPref('skin-tone');
    },
    setSkinTone: function (tone) {
        return this.model.setPref('skin-tone', tone);
    },
    renderEmoji: function () {
        this.renderSkinTonePicker();
        var skinTone = this.getSkinTone();
        var fullEmHtml = [];
        if (this.reaction) {
            fullEmHtml.push('<h2>Reactions</h2>');
            _.each(this.reactions, function (reaction) {
                var key = emoji.map.colons.get(reaction);
                fullEmHtml.push(this.renderSingleEmoji(key, emoji.data[key], skinTone));
            }, this);
        }
        _.each(emoji.categories, function (category) {
            fullEmHtml.push('<h2>');
            fullEmHtml.push(this.formatter.escapeText(category));
            fullEmHtml.push('</h2>');
            _.each(emoji.map.category[category], function (item) {
                fullEmHtml.push(this.renderSingleEmoji(item.key, item.item, skinTone));
            }, this);
        }, this);
        this.list[0].innerHTML = fullEmHtml.join('');
        this.rendered = true;
    },
    afterShow: function () {
        this.focusSearch();
    },
    focusSearch: function () {
        this.searchInput.focus().select();
    },
    show: function (buffer, triggerEl, options) {
        window.getSelection().removeAllRanges();

        options = options || {};

        this.buffer = buffer;
        this.triggerEl = triggerEl;
        this.action = options.action || 'insertAtCursor';
        this.actionData = options.actionData;
        var previousReaction = this.reaction;
        this.reaction = options.reaction;

        if (!this.rendered || this.reaction != previousReaction) {
            this.reset();
        }
        
        var showOptions = {};
        this.triggerEl.attr('aria-expanded', 'true');
        if (this.triggerEl.is('.emojicell')) {
            this.triggerEl.addClass('menuActive');
            showOptions.anchorRight = true;
            showOptions.anchorBottom = true;
        }
        
        var offset = this.triggerEl.offset();
        var x = offset.left + this.triggerEl.outerWidth();
        var y = offset.top;
        
        ContextMenuView.prototype.show.call(this, x, y, showOptions);
    }
});


module.exports = EmojiContextMenuView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/emojicontextmenuview.js
// module id = 52EP
// module chunks = 1